import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="pt-6 pb-8 px-4 relative overflow-hidden" data-id="element-136">
      <div className="max-w-md sm:max-w-lg mx-auto text-center relative z-10" data-id="element-137">
        {/* Attention pill */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="inline-flex items-center gap-2 bg-brand-card border border-brand-danger/40 px-4 py-1.5 rounded-full mb-5" data-id="element-138">
          <span className="w-2 h-2 rounded-full bg-brand-danger animate-pulse" data-id="element-139" />
          <span className="text-[11px] sm:text-xs font-black tracking-wider text-brand-danger uppercase leading-tight" data-id="element-140">
            ATTENZIONE: DOCENTI DI INFORMATICA DI SCUOLA SECONDARIA
          </span>
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.05
      }} className="text-[30px] sm:text-5xl font-black text-brand-cream leading-[1.05] mb-5" data-id="element-141">
          L'intero anno di{' '}
          <span className="text-brand-orange underline decoration-brand-orange/40 underline-offset-4" data-id="element-142">
            Informatica e Coding
          </span>
          , pronto in <span className="text-brand-gold" data-id="element-143">5 minuti</span>.
        </motion.h1>

        {/* Subheadline card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="bg-brand-card border-l-4 border-brand-orange rounded-r-lg px-4 py-3 mb-6 text-left" data-id="element-144">
          <p className="text-sm sm:text-base text-gray-300 leading-snug" data-id="element-145">
            Il primo kit{' '}
            <span className="text-brand-orange font-bold" data-id="element-146">
              "Apri e Insegna"
            </span>{' '}
            con 6 volumi completi e lezioni pronte per Biennio e Triennio.{' '}
            <span className="text-brand-cream font-bold" data-id="element-147">
              Recupera i tuoi Weekend e stupisci i tuoi studenti con progetti
              reali di Python, HTML e Algoritmi.
            </span>
          </p>
        </motion.div>

        {/* Product image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.15
      }} className="mb-6" data-id="element-148">
          <a href="#pricing" className="block cursor-pointer" data-id="element-149">
            <img src="https://cdn.magicpatterns.com/uploads/8AZGoW8frdt9HkGGGKuo4H/my-project-page-1_(8).png" alt="Programmazione Pronta — Kit Scuola Secondaria" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-150" />
          </a>
          <p className="text-xs text-gray-400 font-bold uppercase tracking-wider mt-2" data-id="element-151">
            Programmazione Pronta — Kit Scuola Secondaria
          </p>
        </motion.div>

        {/* Star rating */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="flex items-center justify-center gap-2 mb-3" data-id="element-152">
          <div className="flex" data-id="element-153">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-brand-gold fill-current drop-shadow-[0_0_6px_rgba(251,191,36,0.6)]" data-id="element-154" />)}
          </div>
          <span className="text-sm font-bold text-brand-cream" data-id="element-155">
            4.9/5 (+500 recensioni verificate)
          </span>
        </motion.div>

        {/* Scarcity pill */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.25
      }} className="inline-flex items-center gap-2 border border-brand-orange/40 bg-brand-orange/5 px-4 py-1.5 rounded-full mb-5" data-id="element-156">
          <span className="text-sm font-bold text-brand-orange" data-id="element-157">
            🔥 47 insegnanti hanno scelto questo Kit oggi
          </span>
        </motion.div>

        {/* Main CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} data-id="element-158">
          <CTAButton className="w-full" data-id="element-159">
            SÌ! VOGLIO RECUPERARE IL MIO TEMPO
          </CTAButton>
        </motion.div>

        {/* Trust line */}
        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 mt-5 text-xs text-gray-400 font-medium" data-id="element-160">
          <span data-id="element-161">⚡ Accesso immediato</span>
          <span className="text-gray-600" data-id="element-162">•</span>
          <span data-id="element-163">🛡️ Garanzia di 14 giorni</span>
          <span className="text-gray-600" data-id="element-164">•</span>
          <span data-id="element-165">💳 Pagamento Unico</span>
        </div>

        {/* Country/Resource line */}
        <div className="mt-5 flex items-center justify-center gap-2" data-id="element-166">
          <div className="w-7 h-7 rounded-full overflow-hidden border border-white/20 shadow" data-id="element-167">
            <img src="https://flagcdn.com/w80/it.png" alt="Italia" className="w-full h-full object-cover" data-id="element-168" />
          </div>
          <p className="text-xs text-gray-400 font-medium" data-id="element-169">
            La risorsa N.1 scelta dai docenti di Informatica in tutta Italia.
          </p>
        </div>
      </div>
    </section>;
}